import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { LoggingService } from '../shared/services/logging/logging.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IIndirectStructure, IIndirectStructureResponse } from './IIndirectStructure';

@Injectable({
  providedIn: 'root'
})
export class IndirectJobsService {

  constructor(@Inject(HttpClient) private http: HttpClient,
    @Inject(LoggingService) private log: LoggingService) { }

  private uri = `${environment.apiLocation}/IndirectStructure`;

  public getIndirectJobs(): Observable<Array<IIndirectStructure>> {
    return this.http.get<Array<IIndirectStructure>>(this.uri)
      .pipe(res => {
        this.log.verbose({ type: 'IndirectJobsService:getIndirectJobs:reponse', res });
        return res;
      });
  }

  public putIndirectJobs (indirects: Array<IIndirectStructure>): Observable<IIndirectStructureResponse> {
    this.log.debug({ type: 'IndirectJobsService:putContractStructure', indirects });
    this.log.verbose(JSON.stringify({ indirectsList: indirects }));
    return this.http.put<IIndirectStructureResponse>(this.uri, { IndirectStructureList: indirects })
      .pipe(res => {
        this.log.verbose({ type: 'IndirectJobsService:putContractStructure:reponse', res });
        return res;
      });
  }
}
